import React, { useEffect, useState } from 'react';
import api from '../../api';

const Launch = () => {
  const [status, setStatus] = useState<'loading' | 'error'>('loading');
  const [message, setMessage] = useState('Verifying your secure access link...');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code') || '';

    if (!code) {
      setStatus('error');
      setMessage('This link is missing required information. Please request a new link from your study team.');
      return;
    }

    api.launch.consumeLaunch(code)
      .then((res) => {
        const redirectUrl = res?.data?.redirectUrl || '/game';
        localStorage.removeItem('niji-finalized');
        localStorage.removeItem('niji-skip-to-begin');
        window.location.replace(redirectUrl);
      })
      .catch((error) => {
        const apiMessage = error?.response?.data?.error;
        setStatus('error');
        if (apiMessage === 'Code already used.') {
          setMessage('This link was already used. Please request a new link from your study team.');
          return;
        }
        if (apiMessage === 'Expired code.') {
          setMessage('Your session link has expired. Please request a new link from your study team.');
          return;
        }
        if (apiMessage === 'Bad signature.' || apiMessage === 'Invalid code format.' || apiMessage === 'Invalid payload JSON.') {
          setMessage('This link is invalid. Please request a new link from your study team.');
          return;
        }
        setMessage('We could not verify your link. Please request a new link from your study team.');
      });
  }, []);

  return (
    <div className="instructions-container instructions-container--start">
      <div className="game-finished-container">
        <p className="title">
          {status === 'loading' ? 'Verifying your secure access link…' : message}
        </p>
      </div>
    </div>
  );
};

export default Launch;
